import { createFileRoute, redirect } from "@tanstack/react-router";

/** Redirect old test URL to nested home route. */
export const Route = createFileRoute("/_app/diaries/$diaryId/forms")({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: "/diaries/$diaryId/home/to-do",
            params: { diaryId: params.diaryId },
        });
    },
});
